export class WidgetOptions {
    
    background = {
        colors: null
    };

    // Misc
    uiAnnotations = false;
    uiAudio = false;
    uiInfo = true;
    uiFullscreen = true;

    // Timeline
    uiScrubber = false;

    uiHelp = true;

    // BG logo
    uiBd: '' | 'no-link' | 'false' = '';

    loadRotate: number = null;

    initial = {
        button: false,
        handHint: false,
        play: false
    };

    disableScroll = {
        alert: false,
        overlay: false
    };

    // viewer params
    uiTour = false;
    uiNav = true;
    uiSearch = true;
    uiTools = true;
    uiReset = true;
    uiLabelList = true;
    uiChapterList = true;
    all = false;
    collapseLabel: number = null;
    uiMenu = true;
    uiAnatomyDescriptions = false;
}
